module.exports = __webpack_public_path__ + "img/logo4.e785db3e.png";